var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-main',[_c('v-container',[_vm._t("default")],2)],1),_c('footer-component')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }